import { StylesGroup } from '../../../types';

export const getStylesInfoFromGroup = (groupItems: StylesGroup['items']) => {
  return Object.fromEntries(
    groupItems.map((item) => [item.styleItemId, item.styleItem]),
  );
};
